import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Logo from "@/components/Logo";

export default function Loader() {
  const [done, setDone] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setDone(true), 1100);
    return () => clearTimeout(t);
  }, []);

  return (
    <AnimatePresence>
      {!done && (
        <motion.div exit={{ opacity: 0 }} transition={{ duration: 0.5 }}
          className="fixed inset-0 z-[100] flex flex-col items-center justify-center section-dark" data-testid="page-loader">
          <motion.div initial={{ scale: 0.9, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ duration: 0.4 }}>
            <Logo className="h-32 animate-pulse-soft object-contain" />
          </motion.div>
          <div className="mt-8 h-1 w-40 rounded-full bg-white/10 overflow-hidden">
            <motion.div initial={{ x: "-100%" }} animate={{ x: "0%" }} transition={{ duration: 1, ease: "easeInOut" }}
              className="h-full w-full rounded-full" style={{ background: "linear-gradient(90deg,#ff5147,#f6b64a,#2fd0c6)" }} />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
